import React, {useState} from 'react';
import ReactMarkdown from 'react-markdown';
import {FaEyeSlash, FaEye} from 'react-icons/fa';
import './TaskCard.css';
import {HOST} from "../config";
import {markdownComponents} from '../markdownImage';

const TaskCard = ({card, interactive = true, onHide}) => {
    const [hidden, setHidden] = useState(card.hidden || false);

    if (interactive) {
        return (
            <div className="task-card-container">
                <button className="hide-button" onClick={onHide} title="Hide this task from now on">
                    <FaEyeSlash/>
                </button>
                <div className="task-card">
                    <div className="task-label">Weekly Task</div>
                    <ReactMarkdown components={markdownComponents}>{card.front}</ReactMarkdown>
                </div>
            </div>
        );
    }

    const toggleHidden = () => {
        fetch(HOST + `/api/cards/${card._id}/hidden`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({hidden: !hidden}),
        })
            .then((response) => {
                if (!response.ok) throw new Error('Error updating hidden status.');
                return response.json();
            })
            .then(() => setHidden(!hidden))
            .catch((err) => console.error(err));
    };

    return (
        <div className="task-card-overview">
            <button className="hide-toggle-button" onClick={toggleHidden}>
                {hidden ? <FaEyeSlash title="Unhide this task"/> : <FaEye title="Hide this task"/>}
            </button>
            <div className="task-label">Weekly Task</div>
            <ReactMarkdown components={markdownComponents}>{card.front}</ReactMarkdown>
        </div>
    );
};

export default TaskCard;
